import { useStaleQueries } from "../../hooks/useStaleQueries"
import { RefreshAlert } from "./RefreshAlert"

export function GlobalRefreshAlert() {
   const { hasStaleData, isFetching, refetchAll } = useStaleQueries()

   if (!hasStaleData || isFetching) {
      return null
   }

   return (
      <div style={{ position: "relative", zIndex: 1000 }}>
         <RefreshAlert
            onRefresh={refetchAll}
            isFetching={isFetching}
            message="Des modifications ont été apportées par un utilisateur"
            variant="info"
            buttonText="Rafraîchir"
         />
      </div>
   )
}
